import {Action} from 'js/components/ProviderRegion/actions'
import {ProviderRegionState, Provider} from 'js/types'

import {
  findProviderInfo,
  findRegionInfo,
  findFirstRegion,
} from 'js/components/ProviderRegion/data'

const defaultState: ProviderRegionState = {
  allProviderRegions: {
    providerInfo: [],
    regionInfo: {[Provider.AWS]: [], [Provider.GCP]: []},
  },
  providerInfo: null,
  regionInfo: null,
}

const reducer = (
  state: ProviderRegionState = defaultState,
  action: Action
): ProviderRegionState => {
  switch (action.type) {
    case 'SET_PROVIDER_INFO':
      return {
        ...state,
        providerInfo: findProviderInfo(state, action.payload.provider),
        regionInfo: findFirstRegion(state, action.payload.provider),
      }
    case 'SET_REGION_INFO': {
      const regionInfo = findRegionInfo(state, action.payload.region)

      return {...state, regionInfo}
    }
    default:
      return state
  }
}

export default reducer
